import React from "react";
import { WarningMessageBox } from "../../../messages";

export const AllCommunicationStoppedWarningMessage = () => (
    <WarningMessageBox title="Attention! Communication has been stopped.">
        The clients service preferences indicate that the client does not wish to be contacted.
        You can continue to mark the report as sent but no email communication or notifications will be sent.
    </WarningMessageBox>
);

export const EmailNotificationsDisabledMessage = () => (
    <WarningMessageBox title="Attention! Email Notifications have been stopped.">
        The clients service preferences indicate that the client does not wish to have email notifications
        sent to them. You can continue to mark the report as sent but no email communication will be sent.
    </WarningMessageBox>
);

export const NoEmailsAvailableWarningMessage = () => (
    <WarningMessageBox title="Attention! There are no emails available.">
        There are currently no active email addresses available for this account. You can mark
        the report as sent but no email communication can be sent. Please add some active email
        addresses to the clients details page to be able to send emails.
    </WarningMessageBox>
);